/*
 *  SidePanel.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import styled, { css } from "styled-components";
import React from "react";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const Panel = styled.div`
  position: absolute;
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: ${(props) => props.borderRadius};
  box-shadow: 0 4px 16px 0 #1516331a;
  border: 1px solid #e8e8eb;
  background-color: #fff;
  z-index: 5;
  transition: opacity 0.2s;
  ${(props) =>
    props.side === "top"
      ? css`
          transform: translate(-50%, -100%);
          top: -${props.offset + 6}px;
          left: 50%;
        `
      : props.side === "bottom"
      ? css`
          transform: translate(-50%, 100%);
          bottom: -${props.offset + 6}px;
          left: 50%;
        `
      : props.side === "right"
      ? css`
          transform: translate(100%, -50%);
          right: -${props.offset + 6}px;
          top: 50%;
        `
      : css`
          transform: translate(-100%, -50%);
          left: -${props.offset + 6}px;
          top: 50%;
        `}
  ${(props) =>
    props.active
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          ${props.alwaysVisible
            ? css`
                position: absolute;
                left: -999em;
              `
            : css`
                visibility: hidden;
              `}
        `}
`;
export const PanelContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const PanelArrow = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  z-index: 0;
  ${(props) =>
    props.side === "top"
      ? css`
          transform: translate(-50%, 50%) rotate(45deg);
          bottom: ${props.arrowOffset};
          left: 50%;
          border-radius: 0 0 2px 0;
          border-right: 1px solid #e8e8eb;
          border-bottom: 1px solid #e8e8eb;
        `
      : props.side === "bottom"
      ? css`
          transform: translate(-50%, -50%) rotate(45deg);
          top: ${props.arrowOffset};
          left: 50%;
          border-radius: 2px 0 0 0;
          border-left: 1px solid #e8e8eb;
          border-top: 1px solid #e8e8eb;
        `
      : props.side === "right"
      ? css`
          transform: translate(-50%, -50%) rotate(45deg);
          left: ${props.arrowOffset};
          top: 50%;
          border-radius: 0 0 0 2px;
          border-left: 1px solid #e8e8eb;
          border-bottom: 1px solid #e8e8eb;
        `
      : css`
          transform: translate(50%, -50%) rotate(45deg);
          right: ${props.arrowOffset};
          top: 50%;
          border-radius: 0 2px 0 0;
          border-right: 1px solid #e8e8eb;
          border-top: 1px solid #e8e8eb;
        `}
`;

const SidePanel = ({
  side,
  active,
  width = "384px",
  height = "438px",
  borderRadius = "8px",
  offset = 0,
  arrowOffset = "-1px",
  children,
  padding = 0,
  // alwaysVisible sidepanels wont have a dissapear transition (we need to make them noninteractive by positioning it out of the screen)
  // but you can use functions on its children like ref.current.select()
  alwaysVisible = false,
  className
}) => {
  return (
    <Panel
      active={active}
      side={side}
      width={width}
      borderRadius={borderRadius}
      height={height}
      offset={offset}
      alwaysVisible={alwaysVisible}
      padding={padding}
      className={className}
    >
      <PanelArrow side={side} arrowOffset={arrowOffset} />
      <PanelContent>{children}</PanelContent>
    </Panel>
  );
};

export default SidePanel;
